import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/database'
// const debug = process.env.NODE_ENV !== 'production'
const debug = false // ← เปลี่ยนเป็น false ก่อน deploy

// Dev-build-only settings read from localStorage, written by the dev-tools
// panel. NODE_ENV is folded to a literal at build time, so the whole branch is
// dead-code-eliminated from the production bundle — a customer cannot point
// their browser at an emulator from the console.
function devToolsSetting(key) {
  if (process.env.NODE_ENV === 'production') return null
  if (typeof window === 'undefined' || !window.localStorage) return null
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

// Opt-in local-emulator switch for automated tests. OFF by default, so prod
// and normal dev builds are byte-for-byte unchanged (debug stays false → prod
// Firestore). Set VUE_APP_USE_EMULATOR=1 (e.g. the Playwright dev-server run)
// to route Firestore + Auth to the local Firebase emulators instead, or flip
// it per-browser from the dev-tools panel. Never enable this in a production
// build.
//
// The panel writes the selection to localStorage rather than changing it live:
// `db.settings()` may only be called before Firestore is first used, so the
// switch takes effect on the next page load.
const useEmulator =
  process.env.VUE_APP_USE_EMULATOR === '1' ||
  devToolsSetting('devTools/database') === 'emulator'



const firebaseConfig = {
  apiKey: "AIzaSyCjvS-Bfvf5o5AfERpi20BgMAf4xYtVCuI",
  authDomain: "sld-etax.firebaseapp.com",
  databaseURL: "https://sld-etax.firebaseio.com",
  projectId: "sld-etax",
  storageBucket: "sld-etax.appspot.com",
  messagingSenderId: "360684501775",
  appId: "1:360684501775:web:41d7f43839c2d14fc9dc7a",
  measurementId: "G-5QVXRKWEEL"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore()
let cloudFunctionUrl = "";
let graphqlUrl = "";
let payment2c2pUrl = "";

if (firebase.analytics) {
  firebase.analytics()
}

if (debug || useEmulator) {
  // Emulator hosts default to the repo-standard local ports; overridable via
  // env so a test run can dodge a port already taken by another local service.
  const emuFirestoreHost =
    devToolsSetting('devTools/emulatorFirestore') ||
    process.env.VUE_APP_EMULATOR_FIRESTORE ||
    "localhost:8084";
  const emuAuthUrl =
    devToolsSetting('devTools/emulatorAuth') ||
    process.env.VUE_APP_EMULATOR_AUTH ||
    "http://localhost:9099";
  db.settings({
    host: emuFirestoreHost,
    ssl: false
  });
  firebase.auth().useEmulator(emuAuthUrl);
  // firebase.storage().useEmulator('localhost', 9199); // @firebase/storage 0.3.43 has no useEmulator - throws and stops the app booting
  cloudFunctionUrl = "http://localhost:5001/sld-etax/us-central1/";
  graphqlUrl = "http://localhost/graphql/";
  payment2c2pUrl = "https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/PaymentAuth.aspx";

} else {
  // Force Firestore long-polling in production. The default WebChannel
  // streaming transport keeps one long-lived connection open, which corporate
  // proxies, firewalls, and TLS-inspecting antivirus drop — those clients hit
  // "Failed to get document because the client is offline" and can't log in.
  // Long-polling uses plain HTTP request/response and survives such networks.
  // Forced (not experimentalAutoDetectLongPolling) because auto-detect's
  // runtime reliability is unverified on @firebase/firestore 1.18.0 (firebase
  // 7.24); revisit auto-detect after a v9+ upgrade.
  db.settings({ experimentalForceLongPolling: true });
  cloudFunctionUrl = "https://us-central1-sld-etax.cloudfunctions.net/";
  //cloudFunctionUrl = "http://localhost:5001/sld-etax/us-central1/"; // ← ชี้ไป Emulator Functions เพื่อเทสโค้ดที่แก้
  graphqlUrl = "https://etax-web-backend-4pug4lsila-as.a.run.app/graphql/";
  payment2c2pUrl = "https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/PaymentAuth.aspx";
}

let getImageUrl = "https://images.phasicharoen.com/image_url/get?storage_location=";

const companies = db.collection("Companies")
const users = db.collection("Users")

const auth = firebase.auth()
const storage = firebase.storage()
const rtdb = firebase.database()
const timestampNow = firebase.firestore.Timestamp.now();

// Resolve the URL for a Cloud Function call. By default returns the production
// endpoint (cloudFunctionUrl + name). When the dev-tools panel sets an override
// in localStorage, the function is routed to a local emulator instead — used
// for testing CF changes against prod data without redeploying.
//
// Production builds short-circuit to the prod endpoint and never consult
// localStorage, so a customer can't redirect calls to localhost via the
// browser console.
//
// Override storage (dev builds only, localStorage):
//   "devTools/functions"  → JSON: { [functionName]: "local" | "prod" }
//   "devTools/localBase"  → string: emulator base URL (default 127.0.0.1:5001)
function getFunctionUrl(name) {
  // NODE_ENV is folded to a literal at build time; the localStorage branch
  // below is dead-code-eliminated from the prod bundle entirely.
  if (process.env.NODE_ENV === "production") {
    return cloudFunctionUrl + name
  }
  if (typeof window === "undefined" || !window.localStorage) {
    return cloudFunctionUrl + name
  }
  try {
    const raw = window.localStorage.getItem("devTools/functions")
    if (raw) {
      const overrides = JSON.parse(raw)
      if (overrides && overrides[name] === "local") {
        const base = window.localStorage.getItem("devTools/localBase")
          || "http://127.0.0.1:5001/sld-etax/us-central1/"
        return base + name
      }
    }
  } catch (e) {
    // corrupt JSON → ignore and fall through to prod
  }
  return cloudFunctionUrl + name
}

export default {
  db,
  storage,
  auth,
  rtdb,
  companies,
  users,
  // What this page load actually connected to — the dev-tools panel compares
  // it against the stored selection to tell the developer a reload is pending.
  usingEmulator: useEmulator,
  cloudFunctionUrl,
  getFunctionUrl,
  graphqlUrl,
  getImageUrl,
  payment2c2pUrl,
  analytics: firebase.analytics(),
  timestampNow,
}
